import { Link } from 'gatsby';
import styled from 'styled-components';
import { colors } from 'playful-ui';

export const PlayfulLink = styled(Link)`
  color: ${colors.tomato};
`;
